import React, { useState, useEffect } from 'react';
import { Alert, Space, Button, Form, Select, Spin } from 'antd';
import { PlusOutlined, QuestionCircleOutlined, QuestionOutlined} from '@ant-design/icons';
import useILTCodes from '../../gql/hooks/useILTCodes';
import ModalCompletionCodes from './ModalCompletionCodes';
import './styles.less';

const ILTCodesDropDown = ( { iltID, hideSpinner = true, disabled } ) => {
    const { loadCodes, codes, codesError, codesLoading } = useILTCodes();
    const [ showHelp, setShowHelp ] = useState( false );
    const [ showAdd, setShowAdd ] = useState( false );
    const [ open, setOpen ] = useState( false );
 
    const handleHelpClick = () => {
        setShowHelp( !showHelp );
    };

    useEffect( () => {
        loadCodes( iltID );
    }, [] );

    const handleAddClick = () => {
        setShowAdd( true );
    };

    const handleAddedCode = () => {
        loadCodes( iltID );
        setShowAdd( false );
    };

    return (
        <div className="ilt-code-drop-down">
            { codesLoading && !hideSpinner &&                                                 
                <Spin/>
            }
            
            { codesError && 
                <Alert 
                    type="error"
                    message="An unknown error occurred. Please try again later." 
                />
            }

            { !codesLoading && !codesError && codes &&
                <>
                
                    <Space>
                        <Form.Item 
                            label="Completion Codes"
                            name="completionCodeIDs"
                            style={ { width: 300 } }
                            
                            // rules={ [
                            //     {
                            //         message: 'A completion code is required',
                            //         validateTrigger: [],
                            //         validator: ( _, value ) => {
                            //             if ( value && value.length > 0 ) {
                            //                 return Promise.resolve();
                            //             } else {
                            //                 return Promise.reject();
                            //             }
                            //         }
                            //     }
                            // ] }
                        >
                            <Select
                                mode="multiple" 
                                placeholder="Select Completion Codes" 
                                disabled={disabled}
                                open={ open }
                                onDropdownVisibleChange={ ( visible ) => setOpen( visible ) }
                                onChange={ () => setOpen( false ) }
                                filterOption={ ( input, option ) => 
                                    ( option?.children ? 
                                        option.children[ 0 ].type ? '' : option.children[ 0 ]
                                        : '' ).toLowerCase().includes( input.toLowerCase() )
                                }
                            >
                                {
                                    codes.map( i => {
                                        return ( 
                                            <Select.Option 
                                                key={ i.id } 
                                                value={ i.id }  
                                            >
                                                { i.code || <span className='italic'>No Name</span> }
                                            </Select.Option>
                                        );
                                    } )
                                }
                            </Select>
                        </Form.Item>
                        
                        {disabled ? <></> : <Button   
                            style={ { marginTop: '4px' } }
                            type="text"
                            icon={ <PlusOutlined /> }
                            onClick= { () => handleAddClick() }
                        />}

                        <Button
                            size="small" 
                            disabled={false}
                            shape="circle"
                            style={ { marginTop: '4px' } }
                            onClick={ handleHelpClick }
                        >
                            <QuestionOutlined />
                        </Button>
                    </Space>
                    
                    { showHelp &&
                        <Alert  
                            style={ { marginBottom: '24px' } }
                            type="warning" 
                            description="Session level completion codes are optional. If you do require a session level completion code, only that code will complete the course for your session."
                        />
                    }

                    { showAdd && 
                        <ModalCompletionCodes 
                            iltID={ iltID }
                            finishedCallback={ handleAddedCode }
                        />
                    }
                </>
            }
        </div>
    );
};

export default ILTCodesDropDown;
